export enum GAEventAction {
    CHECK_POLICY = 'checkPolicy',
    CLICK_SOCIAL_ICON = 'clickSocialIcon',
    ENTER_EMAIL = 'enterEmail',
    ENTER_PASS = 'enterPass',
    FAILED_INDEXED_DB = 'failIndexedDB',
    LANDING = 'landing',
    SWITCH_TO_WEBGL = 'switchToWebgl',
    WEBGL_FINISH_LOADING = 'webglFinishLoading',
    WEBGL_START_LOADING = 'webglStartLoading',
    UNITS_TRAIN_SILVER_10000 = 'UNITS_TRAIN_SILVER_10000',
    MARCHES_9 = 'MARCHES_9',
    VALOR_MONSTER_1000 = 'VALOR_MONSTER_1000',
    VALOR_MONSTER_1000_PER_MARCH = 'VALOR_MONSTER_1000_PER_MARCH',
    MONSTER_LVL_5 = 'MONSTER_LVL_5',
    CAPITOL_3 = 'CAPITOL_3',
    HERO_5 = 'HERO_5',
    CLICK_SOCIAL_LOGIN_GOOGLE = 'clickSocialGoogle',
    CLICK_SOCIAL_LOGIN_EMAIL = 'clickSocialEmail',
    CLICK_SOCIAL_LOGIN_FACEBOOK = 'clickSocialFacebook',
}
